import { render, staticRenderFns } from "./AdminPanelEGiftsService.vue?vue&type=template&id=2372020d&"
import script from "./AdminPanelEGiftsService.vue?vue&type=script&lang=js&"
export * from "./AdminPanelEGiftsService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports